import { CSSProperties } from "react";

const MESSAGE = "Something went wrong. Please reload the app.";
const RELOAD_LABEL = "Reload";

//
const styles: Record<string, CSSProperties> = {
  root: {
    position: "fixed",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 24,
    padding: 24,
    zIndex: 9999,
    textAlign: "center",
    backgroundColor: "#141414",
    color: "#FFFFFF",
    fontFamily: "Poppins, sans-serif",
  },
  text: {
    margin: 0,
    fontSize: "clamp(16px, 2.5vw, 22px)",
  },
  button: {
    minWidth: 160,
    padding: "12px 24px",
    border: "none",
    borderRadius: 2,
    backgroundColor: "#1877EB",
    color: "#FFFFFF",
    fontSize: "clamp(14px, 2vw, 16px)",
    fontWeight: 600,
    cursor: "pointer",
  },
};

const FallbackError = () => {
  return (
    <div style={styles.root}>
      <p style={styles.text}>{MESSAGE}</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={styles.button}
        data-gamepad="default-selected"
      >
        {RELOAD_LABEL}
      </button>
    </div>
  );
};

export default FallbackError;
